//@ts-nocheck

"use client";

import clsx from "clsx";
import { useCallback } from "react";

import { Banner } from "@widgets/banner";
import { CulturalObjectMapCard } from "@widgets/cultural-object-map-card";
import { Section } from "@widgets/section";

import { ArticleContent } from "@features/article-content/ui";
import { CulturalObjectHero } from "@features/cultural-object-hero";

import { OtherPointsSection } from "@shared/ui/other-points-section";
import { useScroll } from "@shared/ui/scroll/scroll";
import { SliderCard } from "@shared/ui/slider-card";
import { SharedSocial } from "@shared/ui/social-shared";
import { UniversalGallery } from "@shared/ui/universal-gallery";

import type { CulturalObject } from "../../model";
import { mapCulturalObjectToSliderCard } from "../cultural-objects-page/cultural-objects-page";

import s from "./single-cultural-object-page.module.scss";

export type SingleCulturalObjectPageProps = {
  culturalObject: CulturalObject;
};

export const SingleCulturalObjectPage = (
  props: SingleCulturalObjectPageProps,
) => {
  const { culturalObject } = props;
  const scroll = useScroll();

  const handleMapClick = useCallback(() => {
    if (scroll) {
      scroll.scrollTo("#cultural-object-map", { offset: -100 });
    }
  }, [scroll]);

  return (
    <main className={s.root}>
      <CulturalObjectHero
        backgroundImage={culturalObject.backgroundImage}
        title={culturalObject.title}
        location={culturalObject.location}
        time={culturalObject.travelTime}
        onMapClick={handleMapClick}
      />
      {culturalObject?.content && (
        <ArticleContent
          articleBlocks={culturalObject?.content}
          className={s.content}
          showSocialShare={false}
        />
      )}
      <UniversalGallery
        className={s.container}
        {...culturalObject.gallerySection}
      />
      {/* <div className={s.container}>
        <SharedSocial className={s.socialShare} />
      </div> */}
      <Section
        id="cultural-object-map"
        className={clsx(s.container, s.withoutPaddingTop)}
      >
        <CulturalObjectMapCard
          title="Как добраться"
          primaryObject={culturalObject}
          isVisible={true}
        />
      </Section>
      {culturalObject?.banner?.isVisible && (
        <Banner
          {...culturalObject.banner}
          photo={culturalObject.banner.photo}
        />
      )}
      {culturalObject?.other_objects &&
        culturalObject.other_objects.length > 0 && (
          <OtherPointsSection
            className={s.otherObjectsContainer}
            title="Другие культурные объекты"
            buttonHref="/cultural-objects"
            buttonText="Смотреть все"
            buttonIconName="arrow"
            cardsClassName={s.otherObjects}
          >
            {culturalObject.other_objects.map((otherObject) => (
              <SliderCard
                key={`other_object_card-${otherObject.documentId}`}
                {...mapCulturalObjectToSliderCard(otherObject)}
                context="cultural-objects"
              />
            ))}
          </OtherPointsSection>
        )}
    </main>
  );
};

SingleCulturalObjectPage.displayName = "SingleCulturalObjectPage";
